import React, { FC } from 'react';
import { Panel } from '@component/Panel';
import { ASSETS_PATH } from '@app/react/const/variables';
import {
    OrderPartsHelpContents,
    Title,
    Paragraph,
    Image,
} from './OrderPartsHelpContents';
import { SakuraIcon } from './SakuraIcon';
import { OrderPartsHelpProps } from './type';
import { handleKeyPress } from './handleKeyPress';

const IMG_PATH = `${ASSETS_PATH}/img/order-help/featherinside`;

interface Props {
    className?: string;
}

export const FeatherinsideInner: FC<Props> = ({ className }) => (
    <OrderPartsHelpContents className={className}>
        <Title>
            <SakuraIcon />
            羽中加工について
        </Title>
        <Image src={`${IMG_PATH}/featherinside.png`} />

        <Paragraph>
            羽中加工とは、羽根が付いている部分の下地にデザイン・装飾として施す加工のことです。
            当店ではラインなどの目印となるものや、文字や梵字などもご用意しています。
            射手の願いを込めた装飾やお守り、験担ぎとしても大変おすすめです。
        </Paragraph>
    </OrderPartsHelpContents>
);

export const OrderPartsHelpFeatherinside: FC<OrderPartsHelpProps> = ({
    isOpen,
    handleClose,
}) => (
    <Panel isOpen={isOpen} onRequestClose={handleClose}>
        <div
            className="order-parts-help-panel-close"
            onClick={handleClose}
            onKeyPress={handleKeyPress(handleClose)}
            role="button"
            tabIndex="0"
        >
            <i className="icon-close" />
        </div>
        <div className="order-parts-help-panel">
            <div className="scrollable">
                <FeatherinsideInner />
            </div>
        </div>
    </Panel>
);
